import { render, staticRenderFns } from "./ExperimentManage.vue?vue&type=template&id=4d9a645c&scoped=true&"
import script from "./ExperimentManage.vue?vue&type=script&lang=js&"
export * from "./ExperimentManage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=4d9a645c&scoped=true&lang=css&"
import style1 from "./ExperimentManage.vue?vue&type=style&index=1&id=4d9a645c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a645c",
  null
  
)

export default component.exports